<div fxFlex [fxLayoutAlign]="wrapperLayoutAlign" fxLayoutGap="25px">

  <div fxFlex>
    <form [formGroup]="form"> 
      <mat-form-field class="width-100">
        <input 
          matInput
          #regionInput
          formControlName="region" 
          [matAutocomplete]="regionAC" 
          [placeholder]="'LABEL_REGION' | translate"
          (focus)="!regionAC.isOpen && getInitialValues('region')" 
          (blur)="checkAutocompleteObject(form, 'region')"
          [required]="isRequired"
          >

        <mat-icon 
          id="id_select_region_delete_btn"
          matSuffix 
          color="primary"
          class="clear-input"
          svgIcon="close-circle"
          (click)="regionInput.blur(); clearForm($event)"
          *ngIf="regionInput.value && !disabled"
          >
        </mat-icon>

        <mat-icon 
          matSuffix 
          class="clear-input"
          svgIcon="menu-down"
          *ngIf="!regionInput.value && !disabled"
          >
        </mat-icon>

        <mat-autocomplete 
          id="id_select_region_dropdown"
          [displayWith]="displayFn" 
          #regionAC="matAutocomplete" 
          (closed)="autoCmpltClosed(); regionInput.blur()"
          (opened)="autocompleteScroll('region','regionACRef','regionACTr')"
          >
          <mat-option
            disabled
            *ngIf="!loading.region && listData?.length == 0"
            >
            {{ 'LABEL_NO_DATA' | translate }}
          </mat-option>

          <mat-option
            [id]="'id_select_region_data_' + (i+1)"
            [value]="data" 
            matTooltipPosition="right"
            *ngFor="let data of listData; let i = index" 
            [matTooltip]="data.code + ' - ' + data.description"
            >
            {{ data.code }} - {{ data.description }}
          </mat-option>

          <mat-option *ngIf="loading.region" disabled>
            <mat-spinner color="primary" class="spinner-margin-auto" [diameter]="45"></mat-spinner>
          </mat-option>
        </mat-autocomplete>

        <mat-error *ngIf="form.get('region').hasError('required')">
          {{ 'MSG_FIELD_REQUIRED' | translate }}
        </mat-error>

        <mat-error *ngIf="form.get('region').hasError('notExisting')">
          {{ 'MSG_DOESNT_EXIST' | translate: {type: 'LABEL_REGION' | translate} }}
        </mat-error>
      </mat-form-field>
    </form>
  </div>
  
</div>